import { TabButtonsGroup, useModal } from '@billy/design-system'
import { ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'

import { ModalId } from '../../../../../../enums/modalId'
import { useInvoiceEditor } from '../../contexts/invoiceEditorContext'
import { useInvoiceEditorForm } from '../../contexts/invoiceEditorFormContext'
import { InvoiceEditorView } from '../../enums/invoiceEditorView'

export const InvoiceEditorPreviewToggle = (): ReactElement => {
  const { t } = useTranslation()
  const { open: openLeavePreviewModal } = useModal(ModalId.InvoiceEditorLeavePreviewModal)
  const { isAppearanceSettingsDirtyRef, setView, view } = useInvoiceEditor()
  const { trackInvoiceEditor } = useInvoiceEditorForm()

  const isEditorSelected = view === InvoiceEditorView.Editor
  const isPreviewSelected = view === InvoiceEditorView.Preview

  const handleEditorTabClick = useCallback(() => {
    if (isAppearanceSettingsDirtyRef.current) {
      openLeavePreviewModal()
      return
    }

    setView(InvoiceEditorView.Editor)
    trackInvoiceEditor('Editor/Preview toggle clicked', {
      selectedOption: InvoiceEditorView.Editor,
    })
  }, [isAppearanceSettingsDirtyRef, openLeavePreviewModal, setView, trackInvoiceEditor])

  const handlePreviewTabClick = useCallback(() => {
    setView(InvoiceEditorView.Preview)
    trackInvoiceEditor('Editor/Preview toggle clicked', {
      selectedOption: InvoiceEditorView.Preview,
    })
  }, [setView, trackInvoiceEditor])

  return (
    <TabButtonsGroup>
      <TabButtonsGroup.Button icon="squarePen" onClick={handleEditorTabClick} selected={isEditorSelected}>
        {t('external_invoices.editor.tab.editor')}
      </TabButtonsGroup.Button>
      <TabButtonsGroup.Button icon="eye" onClick={handlePreviewTabClick} selected={isPreviewSelected}>
        {t('external_invoices.editor.tab.preview')}
      </TabButtonsGroup.Button>
    </TabButtonsGroup>
  )
}
